import { useAuthState as rfhUseAuthState } from "react-firebase-hooks/auth";
import firebase from "src/firebase";

export default function useAuthState() {
    return rfhUseAuthState(firebase.auth());
}
